import { formatLocaleData } from "../formatLocale";

export const getDynamicReportContent = ({ value, locale, data }) => {
    try {
        let language = formatLocaleData(locale);
        let result = data?.find(item => {
            return item.name === "reportContent" && item.language === language;
        });

        if (!result) {
            result = data?.find(item => item.name === "reportContent");
        }
        return result?.value;
    } catch (e) {
        return null;
    }
};

export const getDynamicReportType = ({ value, locale, data }) => {
    try {
        let language = formatLocaleData(locale);
        let result = data?.find(item => {
            return item.language === language;
        });
        if (!result) {
            result = value;
        }
        return result?.reportType;
    } catch (e) {
        return null;
    }
};

export const getDynamicReportTypeData = ({ value, locale, data }) => {
    try {
        let language = formatLocaleData(locale);
        let result = data?.find(item => {
            return item.name === "reportType" && item.language === language;
        });

        if (!result) {
            result = data?.find(item => item.name === "reportType");
        }
        return result?.value;
    } catch (e) {
        return null;
    }
};